import React from 'react';
import SkeletonComponent from './SkeletonComponent.jsx';
import 'react-loading-skeleton/dist/skeleton.css';

const SkeletonGrid = ({
  rows = 1,
  cols = 1,
  gap = '1rem',
  skeletonHeight = '100%',
  skeletonWidth = '100%',
  gridWidth = '100%',
  gridHeight = '100%',
  margin = 0,
  baseColor = '#f2f2f2',
  className = ''
}) => {
  const gapValue = typeof gap === 'number' ? `${gap}px` : gap;
  const widthValue = typeof skeletonWidth === 'number' ? `${skeletonWidth}px` : skeletonWidth;
  const heightValue = typeof skeletonHeight === 'number' ? `${skeletonHeight}px` : skeletonHeight;
  const colTemplate = skeletonWidth === '100%'
    ? `repeat(${cols}, 1fr)`
    : `repeat(${cols}, ${widthValue})`;
  const rowTemplate = skeletonHeight === '100%'
    ? `repeat(${rows}, 1fr)`
    : `repeat(${rows}, ${heightValue})`;
  const total = rows * cols;

  return (
    <div
      style={{
        display: 'grid',
        width: gridWidth,
        height: gridHeight,
        gridTemplateColumns: colTemplate,
        gridTemplateRows: rowTemplate,
        gap: gapValue,
        margin
      }}
      className={className}
    >
      {Array.from({ length: total }).map((_, idx) => (
        <SkeletonComponent
          key={idx}
          width={skeletonWidth}
          height={skeletonHeight}
          baseColor={baseColor}
        />
      ))}
    </div>
  );
};


export default SkeletonGrid;
